import ConfirmComponent from './confirm.vue'
let ConfirmConstructor = null;
const Confirm = (option={}) => {
    const confirmDom = new ConfirmConstructor({
        el: document.createElement('div'),
        data() {
            return option;
        }
    });
    document.body.appendChild(confirmDom.$el);
};

export default {
    install(vue) {
        // 返回一个 扩展实例构造器
        ConfirmConstructor = vue.extend(ConfirmComponent);
        // 注册为全局组件
        vue.prototype.$confirm = Confirm;
    }
}
